import paymentElementImageDesktop from "@circle-assets/images/paywalls/payment-form-desktop.png";
import paymentElementImageMobile from "@circle-assets/images/paywalls/payment-form-mobile.png";
import paymentElementImageTablet from "@circle-assets/images/paywalls/payment-form-tablet.png";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";

import I18n from "@/i18n-js/instance";
import { TippyV2 as Tippy } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { PaywallsCheckoutAttemptsPaymentElement } from "../../../../Attempts/PaymentElement";
import { CheckoutFormFieldWrapper } from "../../CheckoutFormFieldWrapper";

export const PaymentElement = () => {
  const { getSelectedPrice, checkoutPreviewContext } =
    usePaywallCheckoutContext();
  const selectedPrice = getSelectedPrice();
  const isCheckoutPreview = !!checkoutPreviewContext;

  return (
    <CheckoutFormFieldWrapper
      name="payment"
      childClassName="!mb-4"
      LabelComponent={Typography.TitleSm}
      addon={
        selectedPrice.trial_enabled && (
          <span className="inline-flex">
            <Tippy
              className="inline-flex"
              content={I18n.t("paywall_checkout.payment_subtitle_tooltip")}
            >
              <Icon type="12-question-mark" size={12} color="text-primary" />
            </Tippy>
          </span>
        )
      }
      data-testid="checkout-form-payment-methods-field-wrapper"
    >
      {isCheckoutPreview && (
        <>
          <img
            src={paymentElementImageDesktop}
            alt=""
            loading="lazy"
            className="hidden lg:block"
          />
          <img
            src={paymentElementImageTablet}
            alt=""
            loading="lazy"
            className="hidden sm:block lg:hidden"
          />
          <img
            src={paymentElementImageMobile}
            alt=""
            loading="lazy"
            className="sm:hidden"
          />
        </>
      )}
      {!isCheckoutPreview && <PaywallsCheckoutAttemptsPaymentElement />}
    </CheckoutFormFieldWrapper>
  );
};
